module.exports = __webpack_public_path__ + "img/276aa8ddef62f85467b2e9c482407ac3.png";